import { getImage } from "../../services/ImageService";

export function AppStoreButton(props) {
    return (
        <a
            className={`h-24 max-w-72 select-none flex ${
                props.className ? props.className : ""
            }`}
            href="https://apps.apple.com/app/id1496583275"
            target="_blank"
            rel="noreferrer"
            draggable={false}
        >
            <img
                className="h-full pointer-events-none"
                src={getImage("buttons/download-black.svg")}
                alt="Download on the App Store"
                draggable={false}
            />
        </a>
    );
}
